import { render } from "./AdminNewsTags.vue?vue&type=template&id=6bdd607a"
import script from "./AdminNewsTags.vue?vue&type=script&lang=js"
export * from "./AdminNewsTags.vue?vue&type=script&lang=js"

import "./AdminNewsTags.vue?vue&type=style&index=0&id=6bdd607a&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__